import { defineStore } from 'pinia';
export const useDBStore = defineStore('db', {
    state: () => ({
        userGroups: []
    }),
    getters: {},
    actions: {},
});
